export const FORM_INITIAL_STATE = {
  orderNumber: "",
  testIdentifier: "",
  typeOfTest: "",
  testSubstrate: "",
  labTestId: "",
  progress: "",

  firstName: "",
  lastName: "",
  dateOfBirth: "",

  additionalEmails: [""],

  testType: "",
  initialFindings: false,
  followUpTest: false,

  dailySymptoms: {
    constipation: false,
    bloating: false,
    diarrhoea: false,
    abdominalPain: false,
    mixed: false,
    flatulence: false,
  },

  selectedTherapist: "",
  otherTherapist: false,
  therapistName: "",
  practiceName: "",
  city: "",
  email: "",
  therapistSearch: "",
  selectedTherapistData: null,

  testSymptoms: {
    bloating: { checked: false, minutes: "" },
    diarrhoea: { checked: false, minutes: "" },
    abdominalPain: { checked: false, minutes: "" },
    others: {
      checked: false,
      symptoms: [{ description: "", minutes: "", wordCount: 0 }],
    },
  },

  consentDeclaration: false,
  dataUsageAgreement: false,
};

export const EDITABLE_STATUSES = ["Dispatched", "Received by Customer"];
